import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, mergeProps as _mergeProps, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { IOptionsSelectFlag } from '@/types';
import { withDefaults, ref, onMounted, watch, computed } from 'vue';

interface IProps {
  modelValue?: any;
  options?: IOptionsSelectFlag[];
  placeholder?: string;
  label?: string;
  width?: string;
  multiple?: boolean;
  disabled?: boolean;
  isCalendar?: boolean;
  required?: boolean;
  hasError?: boolean;
  msgError?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AtomSelectFlag',
  props: {
    modelValue: {},
    options: {},
    placeholder: { default: 'Selecione' },
    label: {},
    width: { default: 'auto' },
    multiple: { type: Boolean, default: false },
    disabled: { type: Boolean },
    isCalendar: { type: Boolean, default: false },
    required: { type: Boolean },
    hasError: { type: Boolean },
    msgError: {}
  },
  emits: ['onChangeDropDownList', 'update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;
const props = __props;

function handleChangeDropdownList() {
  emit('onChangeDropDownList', selectedItem.value);
}

const selectedFlag = ref<string>('br')

const selectedItem = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value)
})


// watch(
//   () => props.options,
//   () => {
//     if (!selectedItem.value)
//       selectedItem.value = props.options?.find((x) => x.selected === true)?.value;
//     emit("onChangeDropDownList", selectedItem.value);
//   }
// );


return (_ctx: any,_cache: any) => {
  const _component_country_flag = _resolveComponent("country-flag")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_select = _resolveComponent("v-select")!

  return (_openBlock(), _createElementBlock("div", {
    style: _normalizeStyle({ width: props.width })
  }, [
    _createVNode(_component_v_select, {
      modelValue: selectedFlag.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedFlag).value = $event)),
      placeholder: props.placeholder,
      items: props.options,
      "item-value": "value",
      density: "compact",
      variant: "outlined",
      "item-title": "selected",
      required: false,
      disabled: false,
      "hide-details": true,
      class: "pa-0"
    }, {
      item: _withCtx(({ props, item }) => [
        _createVNode(_component_v_list_item, _mergeProps(props, {
          subtitle: item.raw.department
        }), {
          default: _withCtx(() => [
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "4" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_country_flag, {
                      country: item.raw.value,
                      size: "medium"
                    }, null, 8, ["country"])
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_v_col, {
                  cols: "8",
                  class: "pt-5"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.raw.text), 1)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1040, ["subtitle"])
      ]),
      selection: _withCtx(({}) => [
        _createElementVNode("div", null, [
          _createVNode(_component_country_flag, {
            country: selectedFlag.value,
            size: "big"
          }, null, 8, ["country"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "placeholder", "items"])
  ], 4))
}
}

})